<template>
    <div class="">
        <el-button>hello</el-button>
        <ElButton>lijiahao</ElButton>
    </div>
</template>

<script>
export default {
    name: 'CommonButton',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    computed: {},
    watch: {},
    methods: {},
    mounted() { },
};
</script>

<style scoped lang="scss">
  @import "element-ui/lib/theme-chalk/button.css";
</style>
